/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Invoice_Company_AddressInputs */

const vi_validation_invoice_company_address = /** @type {(inputs: Validation_Invoice_Company_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập địa chỉ công ty`)
};

/**

* @param {Validation_Invoice_Company_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_invoice_company_address = /** @type {((inputs?: Validation_Invoice_Company_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Invoice_Company_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_invoice_company_address(inputs)
});